import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store, persistor } from "./store/store";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { CommonProvider } from "./contexts/CommonContext";
import { Spin } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "./store/rootReducer";

const LoadingSpinner = () => {
  const loading = useSelector((state: RootState) => state.loading.loading);

  return <Spin fullscreen spinning={loading} />;
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <PersistGate persistor={persistor}>
        <CommonProvider>
          <LoadingSpinner />
          <App />
        </CommonProvider>
      </PersistGate>
    </BrowserRouter>
  </Provider>,
);

reportWebVitals();
